import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "tw-mt-4 tw-text-2xl tw-font-bold tw-text-[#0C0F4A] tw-tracking-[0.25px] tw-text-center" }, " Send Invitation? ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-2 tw-text-sm tw-font-bold tw-text-[#0c0f4a80] tw-tracking-[0.14px] tw-text-center" }, " Are you sure you want to send invitation for estimation? ", -1)
const _hoisted_3 = { class: "tw-flex tw-gap-3 tw-items-center tw-justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    showBackButton: false,
    onOnClose: $setup.onClickCancel
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          label: "CANCEL",
          variant: "secondary",
          class: "button !tw-w-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickCancel()))
        }),
        _createVNode(_component_Button, {
          label: "CONFIRM",
          variant: "accent",
          class: "button !tw-w-auto",
          onClick: $setup.onClickConfirmButton
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}